<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts'
// require('echarts/theme/macarons') // echarts theme
import resize from '@Sys~/components/mixins/resize'

import FileSaver from 'file-saver'
import XLSX from 'xlsx'

export default {
  mixins: [resize],
  props: {
    id: {
      type: String,
      default: "chart"
    },
    name: {
      type: String,
      default: "chart"
    },
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      // default: () => {}
      required: true
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        // console.log('===图11111：==',val)
        const data = JSON.parse(JSON.stringify(val))
        this.setOptions(data)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },

  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      const data = JSON.parse(JSON.stringify(this.chartData))
      this.setOptions(data)
      // console.log('=图22222====',data)
    },
    setOptions(cusdata) {
      // console.log('===重置图===')
      // 专项设置
      const ids = this.id;
      const xname = this.name;
      if(!cusdata.color){
        cusdata.color = ['#6C9AFA','#6BDCAF','#FFA358','#EA7464','#7CCEEE','#F7C42E','#7F75B5','#97A1ED','#E4D6FE','#359F9E','#EFA18D','#4AA9A8','#D2E0FD','#D87C7C','#6E7F9D','#787464','#89AEFB']
      }
      
      
      cusdata.tooltip.textStyle = {
        align:'left'
      }
      // 格式化yAxis
      if (cusdata.yAxis && cusdata.yAxis.length > 0) {
        // 去掉Y轴 横线
        // cusdata.yAxis = {
        //   axisLine:{
        //     show:false
        //   },
        //   axisTick:{
        //     show:false
        //   },
        // }

        if (Array.isArray(cusdata.yAxis)) {
          for (var i = 0; i < cusdata.yAxis.length; i++) {
            if (cusdata.yAxis[i].axisLabel) {
              if (cusdata.yAxis[i].axisLabel.formatter == undefined) {
                cusdata.yAxis[i].axisLabel.formatter = function (value) {
                  if (value > 10000 * 10000 * 10000 - 1) {
                    return (
                      parseFloat(value / (10000 * 10000 * 10000)).toFixed(1) +
                      " 兆"
                    );
                  } else if (value > 10000 * 10000 - 1) {
                    return (
                      parseFloat(value / (10000 * 10000)).toFixed(1) + " 亿"
                    );
                  } else if (value > 10000 - 1) {
                    return parseFloat(value / 10000).toFixed(1) + " 万";
                  } else {
                    return value;
                  }
                };
              }
            }
          }
        } else {
          if (cusdata.yAxis.axisLabel) {
            if (cusdata.yAxis.axisLabel.formatter == undefined) {
              cusdata.yAxis.axisLabel.formatter = function (value) {
                if (value > 10000 * 10000 * 10000 - 1) {
                  return (
                    parseFloat(value / (10000 * 10000 * 10000)).toFixed(1) +
                    " 兆"
                  );
                } else if (value > 10000 * 10000 - 1) {
                  return parseFloat(value / (10000 * 10000)).toFixed(1) + " 亿";
                } else if (value > 10000 - 1) {
                  return parseFloat(value / 10000).toFixed(1) + " 万";
                } else {
                  return value;
                }
              };
            }
          }
        }
      }

       // 格式化表格 和 下载
      if (cusdata.toolbox && JSON.stringify(cusdata.toolbox) !== '{}') {
        // console.log('feature1111111111',cusdata.toolbox.feature)
        if (JSON.stringify(cusdata.toolbox.feature) !== '{}') {
          if (JSON.stringify(cusdata.toolbox.feature.dataView) !== '{}') {
            cusdata.toolbox.feature.dataView.readOnly = false;
            cusdata.toolbox.feature.dataView.lang = ['数据视图', '关闭', '导出图表数据']
            cusdata.toolbox.feature.dataView.textColor ="#666"
            cusdata.toolbox.feature.dataView.optionToContent = function (opt) {
              // console.log('opt====',opt)
              var table = "";
              if (opt.xAxis[0].type != "value") {
                var axisData = opt.xAxis[0].data;//获取图形的data数组
              } else {
                var axisData = opt.yAxis[0].data;//获取图形的data数组
              }
              var series = opt.series;//获取series
              table += '<table class="bordered" id="tubiaoxiazai' + ids + '"><thead><tr>'
                + '<th> </th>';
              for (var i = 0; i < series.length; i++) {
                table += '<th>' + series[i].name + '</th>'
              }
              table += '</tr></thead><tbody>';
              for (var i = 0, l = axisData.length; i < l; i++) {
                table += '<tr>'
                  + '<td>' + axisData[i] + '</td>';
                for (var j = 0; j < series.length; j++) {
                  if (series[j].data[i]) {
                    table += '<td>' + series[j].data[i] + '</td>';
                  } else {
                    table += '<td>' + 0 + '</td>';
                  }
                }
                table += '</tr>';
              }
              return table;
            }

            cusdata.toolbox.feature.dataView.contentToOption = function (opt) {
              // console.log(xname)
              if (xname == "") {
                xname = "新文件"
              }
              /* generate workbook object from table */
              var wb = XLSX.utils.table_to_book(document.querySelector('#tubiaoxiazai' + ids))
              /* get binary string as output */
              var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
              try {
                FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), xname + '.xlsx')
              } catch (e) { if (typeof console !== 'undefined') console.log(e, wbout) }
              return wbout
            }
          }
        }
      }

      this.chart.setOption(cusdata,true)
     
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .bordered {
  width: 100%;
  border-top: 1px solid #dfe6ec;
  border-left: 1px solid #dfe6ec;
}

::v-deep .bordered th {
  padding: 7px;
  text-align: center;
  font-size: 14px;
  color: #666;
  border-right: 1px solid #dfe6ec;
  border-bottom: 1px solid #dfe6ec;
}

::v-deep .bordered td {
  padding: 7px;
  text-align: center;
  font-size: 12px;
  color: #666;
  border-right: 1px solid #dfe6ec;
  border-bottom: 1px solid #dfe6ec;
}

::v-deep .bordered th {
  background: rgb(238, 241, 246);
}
::v-deep .bordered td:first-child,
::v-deep .bordered th:first-child {
  border-left: none;
}

::v-deep .bordered tr:nth-of-type(2n) {
  background: #ffffff;
}
::v-deep .bordered tr:nth-of-type(2n + 1) {
  background: #f7fafc;
}
</style>
